"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var TemplatesMonitoring_1 = require("../monitoring/TemplatesMonitoring");
var VizportalApi_1 = require("../vizportalapi/VizportalApi");
var WorkbookFromTemplateFactory;
(function (WorkbookFromTemplateFactory) {
    function createWorkbookWithoutProjectSelection(workbookName, credentialId, templateId, connectionType, onTemplateCreated, createWorkbookInNewTab) {
        if (createWorkbookInNewTab === void 0) { createWorkbookInNewTab = true; }
        return __awaiter(this, void 0, void 0, function () {
            var projects, defaultProject, result, success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, VizportalApi_1.VizportalApiService.GetDestinationProjects()];
                    case 1:
                        projects = _a.sent();
                        defaultProject = projects.filter(function (project) { return project.isDefaultProject; });
                        if (!(defaultProject.length === 1)) return [3 /*break*/, 3];
                        TemplatesMonitoring_1.monitorStartWorkbookCreation(templateId, connectionType.internalName, credentialId);
                        return [4 /*yield*/, VizportalApi_1.VizportalApiService.CreateWorkbookFromTemplate(templateId, workbookName, credentialId, defaultProject[0].id, connectionType.internalName)];
                    case 2:
                        result = _a.sent();
                        // If we receive a non empty edit url, we know we've successfully created workbook
                        try {
                            success = result.workbookEditUrl.length > 0;
                            TemplatesMonitoring_1.monitorWorkbookCreated(templateId, connectionType.internalName, success);
                            onTemplateCreated(success, result.workbookEditUrl, createWorkbookInNewTab);
                        }
                        catch (_b) {
                            TemplatesMonitoring_1.monitorWorkbookCanceled(templateId, connectionType.internalName);
                            onTemplateCreated(false, '');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        // TODO: Default project not found for user show project picker tfs1063610
                        onTemplateCreated(false, '');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    WorkbookFromTemplateFactory.createWorkbookWithoutProjectSelection = createWorkbookWithoutProjectSelection;
    function createWorkbook(templateId, workbookName, connectionType, credentialId, projectId, onTemplateCreated) {
        return __awaiter(this, void 0, void 0, function () {
            var result, success, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        TemplatesMonitoring_1.monitorStartWorkbookCreation(templateId, connectionType.internalName, credentialId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, VizportalApi_1.VizportalApiService.CreateWorkbookFromTemplate(templateId, workbookName, credentialId, projectId, connectionType.internalName)];
                    case 2:
                        result = _b.sent();
                        success = result.workbookEditUrl.length > 0;
                        TemplatesMonitoring_1.monitorWorkbookCreated(templateId, connectionType.internalName, success);
                        onTemplateCreated(success, result.workbookEditUrl);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        TemplatesMonitoring_1.monitorWorkbookCanceled(templateId, connectionType.internalName);
                        onTemplateCreated(false, '');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    WorkbookFromTemplateFactory.createWorkbook = createWorkbook;
})(WorkbookFromTemplateFactory = exports.WorkbookFromTemplateFactory || (exports.WorkbookFromTemplateFactory = {}));
//# sourceMappingURL=WorkbookFromTemplateFactory.js.map